import { Routes } from '../../../../models/enums/routes';
import {
  InnerUnderline,
  JobItemWrapper,
  JobPosition,
  JobSalary,
  Underline,
} from './jobItem.styles';
import { IJobSummary } from '../interfaces';
import { RichText } from 'prismic-reactjs';

export const JobItem = ({ position, salary, seo_url }: IJobSummary) => {
  return (
    <JobItemWrapper>
      <JobPosition href={`${Routes.CareersId}${RichText.asText(seo_url)}`}>
        <Underline>
          <InnerUnderline>{RichText.asText(position)}</InnerUnderline>
        </Underline>
      </JobPosition>

      <JobSalary>{RichText.asText(salary)}</JobSalary>
    </JobItemWrapper>
  );
};
